import * as React from 'react'
import { isNull } from 'lodash'
import AppBadge from './app-badge'

function RoleScoreBadge({
  count,
  showCount = false,
  mid = 20,
  high = 40,
  critical = 60
}) {
  if (count === undefined || count === null) {
    return <React.Fragment></React.Fragment>
  }
  if (count >= critical) {
    return (
      <AppBadge
        pill
        variant="danger"
        className="text-center text-danger fw-normal"
        style={{ backgroundColor: '#E77152' }}
        data-testid={'risk-badge'}
      >
        {showCount ? count : 'Critical'}
      </AppBadge>
    )
  }

  if (count >= high) {
    return (
      <AppBadge
        pill
        variant="high"
        className="text-center fw-normal"
        style={{ backgroundColor: '#fd7e14' }}
        data-testid={'risk-badge'}
      >
        {showCount ? count : 'High'}
      </AppBadge>
    )
  }

  if (count >= mid) {
    return (
      <AppBadge
        pill
        variant="warning"
        className="text-center fw-normal"
        style={{ backgroundColor: '#38BEC9' }}
        data-testid={'risk-badge'}
      >
        {showCount ? count : 'Medium'}
      </AppBadge>
    )
  }

  if (count >= 0 || isNull(count)) {
    return (
      <AppBadge
        pill
        variant="secondary"
        className="text-center fw-normal"
        style={{ backgroundColor: '#27AB83' }}
        data-testid={'risk-badge'}
      >
        {showCount ? count : 'Low'}
      </AppBadge>
    )
  }
}

export default RoleScoreBadge
